import { isBrowser } from "../../utils/environmentDetection/library";
/**
 * Returns the SURVEYCONFIG object either from the CBC.APP.ANA object
 * @returns {object | null} SURVEYCONFIG object
 */
export const getSurveyConfig = () => {
    let surveyConfig = null;

    if (isBrowser()) {
        if (window.CBC?.APP?.ANA?.SURVEYCONFIG) {
            surveyConfig = window.CBC?.APP?.ANA?.SURVEYCONFIG;
        }
    }
    return surveyConfig;
};

export const onDidomiCMPHidden = (callback) => {
    window.CBCCMPQueue = window.CBCCMPQueue || [];
    window.CBCCMPQueue.push((CMPProviders, CBCCMPSettings) => {
        if (CBCCMPSettings.cmpEnabled && CBCCMPSettings.cmpScriptWillBeLoaded) {
            const isVisible = CMPProviders?.didomi?.notice.isVisible();
            if (!isVisible) callback();
        }
    });
};
